// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1uLlr","requiredAsterisk":"Info_requiredAsterisk__-4M54"};